'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$() {
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$ as $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$ as $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$ };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return (-1950496919);
});
$p.b = (function() {
  return "Number";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "Number";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.y = (function(p) {
  return this;
});
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$, "be.doeraene.webcomponents.ui5.configkeys.InputType$Number$", ({
  gw: 1,
  b0: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$ as $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$ };
var $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$;
function $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$)) {
    $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$ = new $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$ as $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Number$ };
